import {
    GET_ALL_USER_REGION_REQUEST, GET_ALL_USER_REGION_ERROR, GET_ALL_USER_REGION_SUCCESS,
    ADD_USER_REGION_REQUEST, ADD_USER_REGION_ERROR, ADD_USER_REGION_SUCCESS,
    UPDATE_USER_REGION_REQUEST, UPDATE_USER_REGION_ERROR, UPDATE_USER_REGION_SUCCESS,
    DELETE_USER_REGION_REQUEST, DELETE_USER_REGION_ERROR, DELETE_USER_REGION_SUCCESS,
} from "../actions/types";


export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case GET_ALL_USER_REGION_REQUEST:
        return {
          loading: true,
        };
      case GET_ALL_USER_REGION_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_ALL_USER_REGION_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
        case ADD_USER_REGION_REQUEST:
          return {
              loading: true,
          };
      case ADD_USER_REGION_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case ADD_USER_REGION_ERROR:
          return {
              ...state,
              loading: false
          };
      case DELETE_USER_REGION_REQUEST:
          return {
              loading: true,
          };
      case DELETE_USER_REGION_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case DELETE_USER_REGION_ERROR:
          return {
              ...state,
              loading: false
          };
      case UPDATE_USER_REGION_REQUEST:
          return {
              loading: true,
          };
      case UPDATE_USER_REGION_SUCCESS:
          return {
              ...state,
              loading: false,
              payload: [payload],
          };
      case UPDATE_USER_REGION_ERROR:
          return {
              ...state,
              loading: false
          };
        
      default:
        return state;
    }
  }
  